import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function PatientProfile() {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  useEffect(() => {
    api.get("/me/profile").then(({ data }) => setProfile(data.profile)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="space-y-6" data-testid="patient-profile-page">
      <header>
        <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">Profile</p>
        <h1 className="text-3xl font-bold mt-1">{user?.name}</h1>
        <p className="text-muted-foreground mt-1">{user?.email}</p>
      </header>
      <div className="nt-card p-5 space-y-3 text-sm">
        {profile && Object.keys(profile).length > 0 ? (
          Object.entries(profile)
            .filter(([k]) => !["patient_id", "dietitian_id", "created_at", "updated_at"].includes(k))
            .map(([k, v]) => (
              <div key={k} className="flex justify-between gap-3 border-b border-border last:border-0 pb-2 last:pb-0">
                <span className="text-muted-foreground capitalize">{k.replace(/_/g, " ")}</span>
                <span className="font-medium text-right">{String(v)}</span>
              </div>
            ))
        ) : (
          <p className="text-muted-foreground">Your dietitian will fill this in soon.</p>
        )}
      </div>
    </div>
  );
}
